export class Settings {
    public static VERSION = '1.0.1';
    public static TERM_URL = 'https://duka.digital';

    constructor() {
    }
}
